// The period a group's network usage covers (D81): 1, 3 or 7 days, 7 by default — the API
// keeps 7 days and purges the rest. The choice is this browser's, remembered across pages.
import { useState } from "react";

export const DAY_CHOICES = [1, 3, 7] as const;
export type Days = (typeof DAY_CHOICES)[number];
const KEY = "ocs.network.days";

export function readDays(): Days {
  try {
    const saved = Number(localStorage.getItem(KEY));
    return (DAY_CHOICES as readonly number[]).includes(saved) ? (saved as Days) : 7;
  } catch {
    return 7;
  }
}

export function useDays(): [Days, (d: Days) => void] {
  const [days, set] = useState<Days>(readDays);
  return [
    days,
    (d: Days) => {
      set(d);
      try {
        localStorage.setItem(KEY, String(d));
      } catch {
        // Private windows may refuse storage; the choice still holds for this page.
      }
    },
  ];
}
